import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'cpfCnpjPixMask'})
export class CpfCnpjPixPipe implements PipeTransform {

	transform(str: string) {
		if (str) {
			if (str.length === 0) {
				return '';
			} else if (str.length <= 11) {
				return str.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})/, '***.$2.$3-**');
			} else if (str.length <= 14) {
				return str.replace(/^(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/, '$1.$2.$3/$4-$5');
			}
		}

		return str;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/cpf-cnpj-pix.pipe.ts